import { render, staticRenderFns } from "./BlockBlogListItemOverlay.vue?vue&type=template&id=4c91df8f&scoped=true&"
var script = {}
import style0 from "./BlockBlogListItemOverlay.vue?vue&type=style&index=0&id=4c91df8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c91df8f",
  null
  
)

export default component.exports